import { toPlainText } from "../utils/plainText";
import "../reportDashboard.scss";

// Responsive grid of bounded chips — replaces comma-joined name lists in the
// credential-type, issuing-body and meeting-attendee modals.
// items: string[]
const ChipGrid = ({ items, emptyLabel = "No records" }) => {
  const list = (items || []).filter(Boolean);
  if (list.length === 0) {
    return <div className="rdEmpty">{emptyLabel}</div>;
  }
  return (
    <div className="rdChipGrid">
      {list.map((item, i) => {
        const label = toPlainText(item);
        return (
          // eslint-disable-next-line react/no-array-index-key
          <div className="rdChipGrid__chip" key={`${label}-${i}`} title={label}>
            {label}
          </div>
        );
      })}
    </div>
  );
};

export default ChipGrid;
